export default "__VITE_ASSET__DXHHt3GM__"